import { isFunction } from "../../../utils/type-checking/type-checking.es.js";
import { CustomArrowButtonDirections } from "../interfaces/custom-arrow-button.interface.es.js";
const EMPTY_STRING = "";
const DEFAULT_STEP = 1;
const NUMBER_INPUT_ALLOWED_KEYS = /* @__PURE__ */ new Set(["-", "Backspace", "Enter", "ArrowRight", "ArrowLeft", "Delete"]);
const IS_NUMBER_CHARACTER_REGEX = /^\d$/;
function computeNewValueBasedOnDirection({
  direction,
  value,
  step = DEFAULT_STEP,
  minValue,
  maxValue
}) {
  const updateStep = direction === CustomArrowButtonDirections.up ? step : -step;
  const parsedCurrentValue = Number(value);
  let newValue = updateStep;
  if (!isNaN(parsedCurrentValue)) {
    newValue = parsedCurrentValue + updateStep;
  }
  return getNextBestValue({
    newValue,
    minValue,
    maxValue
  });
}
function computeNewValueBasedOnUserInput({
  newValue,
  minValue,
  maxValue
}) {
  const isNewValueEmpty = isValueEmpty(newValue);
  const isNewValueTheMinusSymbol = newValue === "-";
  if (isNewValueEmpty || isNewValueTheMinusSymbol) {
    return EMPTY_STRING;
  }
  const parsedValue = Number(newValue);
  if (!isNaN(parsedValue)) {
    return getNextBestValue({
      newValue: parsedValue,
      minValue,
      maxValue
    });
  }
  return EMPTY_STRING;
}
function isLabelShrunk(currentValue, isFocused) {
  return isFocused || !isValueEmpty(currentValue);
}
function isAllowedKey(key) {
  return IS_NUMBER_CHARACTER_REGEX.test(key) || NUMBER_INPUT_ALLOWED_KEYS.has(key);
}
function callOnChangeWithNewValue(newValue, onChange) {
  if (isFunction(onChange)) {
    onChange(newValue);
  }
}
function getNextBestValue({
  newValue,
  minValue,
  maxValue
}) {
  if (isValueInRange({
    newValue,
    minValue,
    maxValue
  })) {
    return newValue;
  } else if (!isValueBelowOrEqualToMaxValue({
    newValue,
    maxValue
  })) {
    return maxValue ?? EMPTY_STRING;
  } else {
    return minValue ?? EMPTY_STRING;
  }
}
function isValueInRange(props) {
  return isValueAboveOrEqualToMinValue(props) && isValueBelowOrEqualToMaxValue(props);
}
function isValueAboveOrEqualToMinValue({
  newValue,
  minValue
}) {
  return minValue === void 0 || Number(newValue) >= minValue;
}
function isValueBelowOrEqualToMaxValue({
  newValue,
  maxValue
}) {
  return maxValue === void 0 || Number(newValue) <= maxValue;
}
function isValueEmpty(currentValue) {
  const isDefined = currentValue !== void 0 && currentValue !== null;
  if (isDefined && typeof currentValue === "string") {
    return currentValue.length <= 0;
  }
  return !isDefined;
}
export {
  DEFAULT_STEP,
  EMPTY_STRING,
  NUMBER_INPUT_ALLOWED_KEYS,
  callOnChangeWithNewValue,
  computeNewValueBasedOnDirection,
  computeNewValueBasedOnUserInput,
  isAllowedKey,
  isLabelShrunk
};
//# sourceMappingURL=number-input-functions.es.js.map
